import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';
import { useSnackbar } from 'notistack';
import Loding from 'routes/partials/Loding';
import MultipleLimits from './MultipleLimits';
import MultipleRequirements from './MultipleRequirements';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
    maxWidth: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const TierAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const NoImage = '/images/icons/system.png';
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [id, setId] = useState('');

  const [title, setTitle] = useState('');
  const [priority, setPriority] = useState('');
  const [subtitle, setSubTitle] = useState('');
  const [typeOfAccount, setTypeOfAccount] = useState('');
  const [limit, setLImit] = useState('');
  const [allLimits, setAllLimits] = useState([]);

  const [dailyMaxNumber, setDailyMaxNumber] = useState('');
  const [dailyMaxAmount, setDailyMaxAmount] = useState('');

  const [monthlyMaxNumber, setMonthlyMaxNumber] = useState('');
  const [monthlyMaxAmount, setMOnthlyMaxAmount] = useState('');

  const [requirements, setRequirements] = useState([]);
  const [imageFile, setImageFile] = useState(null);

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [preview, setPreview] = useState(NoImage);
  const [allRequirements, setAllRequirements] = useState([]);
  const [message, setMessage] = useState('There is no data');

  console.log('editForm', editForm);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearStates = () => {
    setId('');
    setTitle('');
    setPriority('');
    setSubTitle('');
    setTypeOfAccount('');
    setDailyMaxNumber('');
    setDailyMaxAmount('');
    setMonthlyMaxNumber('');
    setMOnthlyMaxAmount('');
    // setRequirements('');

    setImageFile(null);
    setPreview(NoImage);
    setStatus(false);

    setEditObj({});
  };

  const validation = () => {
    // let isError = false;
    // if (!name.trim()) {
    //   console.log('name');
    //   handleSnakbarOpen('Please enter name', 'error');
    //   document.getElementById('name').focus();
    //   return (isError = true);
    // }
    // if (!code.trim()) {
    //   handleSnakbarOpen('Please enter code', 'error');
    //   document.getElementById('code').focus();
    //   return (isError = true);
    // }
    // if (!currency.trim()) {
    //   console.log('currency');
    //   handleSnakbarOpen('Please enter currency', 'error');
    //   document.getElementById('currency').focus();
    //   return (isError = true);
    // }
    // if (!continent.trim()) {
    //   console.log('continent');
    //   handleSnakbarOpen('Please enter continent', 'error');
    //   document.getElementById('continent').focus();
    //   return (isError = true);
    // }
    // if (!phone.trim()) {
    //   console.log('phone');
    //   handleSnakbarOpen('Please enter phone number', 'error');
    //   document.getElementById('phone').focus();
    //   return (isError = true);
    // }
    // console.log('finish');
    // return isError;
  };

  const getRequirement = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .get('/api/v1/private/requirement', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setAllRequirements(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const getLimits = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .get('/api/v1/private/limit-restrictions', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setAllLimits(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const onSubmit = async e => {
    // return console.log('image file', imageFile)
    // return console.log('ddddd', imageFile);
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      console.log('onSubmit');
      console.log('editIndexNo', editIndexNo);
      e.preventDefault();
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      const formdata = new FormData();
      formdata.append('title', title);
      formdata.append('priority', priority);
      formdata.append('subTitle', subtitle);
      formdata.append('typeOfAccount', typeOfAccount);
      formdata.append('limit', limit);
      formdata.append('requirements', requirements.join(', '));
      formdata.append('status', status);

      if (imageFile) {
        formdata.append('logo', imageFile);
      } else {
        formdata.append('logo', '');
      }

      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/tier`,
            method: 'post',
            data: formdata,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setList([...list, response.data.data]);

          console.log('addForm response', response);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/tier/${id}`,
            method: 'put',
            data: formdata,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('editForm response', response);

          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
        }

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
    // handleSnakbarOpen()
  };

  const imageProcess = e => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      console.log('image file', imageFile);
      setImageFile(imageFile);

      const reader = new FileReader();
      reader.onload = x => {
        setImageFile(imageFile);
        setPreview(x.target.result);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setImageFile(imageFile);
      setPreview(preview);
    }
  };

  const handleChange = event => {
    setRequirements(event.target.value);
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    console.log('loading edit data', editObj);

    if (editObj.id) {
      console.log('loading edit data 2');

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setTitle(editObj.title);
      setPriority(editObj.priority);
      setSubTitle(editObj.subTitle);
      setTypeOfAccount(editObj.typeOfAccount);

      setPreview(editObj.logo);

      // setLImit(editObj.limit);
      // setRequirements(editObj.requirements);
      setStatus(editObj.status);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();
  };

  useEffect(() => {
    getRequirement();
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);

  useEffect(() => {
    getLimits();
  }, []);

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Tier' : 'Add Tier'}
        </Typography>
      </div>

      <form onSubmit={onSubmit}>
        <TextField
          id="title"
          label="Title"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <TextField
          id="subtitle"
          label="Subtitle"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={subtitle}
          onChange={e => setSubTitle(e.target.value)}
        />
        <TextField
          id="typeOfAccount"
          label="Type of Account"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={typeOfAccount}
          onChange={e => setTypeOfAccount(e.target.value)}
        />
        <TextField
          id="priority"
          label="Priority"
          variant="outlined"
          type="number"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={priority}
          onChange={e => setPriority(e.target.value)}
        />
        {/* <TextField
        variant="outlined"
        select
        label="Limit"
        size="small"
        fullWidth
        required
        value={limit}
        onChange={e => setLImit(e.target.value)}
        className={`${classes.marginStyle} ${classes.inputStyle}`}>
        {allLimits.map((item, index) => (
          <MenuItem value={item.id} key={index}>
            {item.recurrence}
          </MenuItem>
        ))}
      </TextField> */}

        <MultipleLimits allValue={allLimits} value={limit} setValue={setLImit} title="Limits" preValue={editObj.limit} />
        <MultipleRequirements
          allValue={allRequirements}
          value={requirements}
          setValue={setRequirements}
          title="Requirements"
          preValue={editObj.requirements}
        />
        {/* <TextField
        id="continent"
        label="Daily Max Number Of Transaction"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={dailyMaxNumber}
        onChange={e => setDailyMaxNumber(e.target.value)}
      />
      <TextField
        id="phone"
        label="Daily Max Total Amount Of Transaction"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={dailyMaxAmount}
        onChange={e => {
          setDailyMaxAmount(e.target.value);
        }}
      />
      <TextField
        id="continent"
        label="Monthly Max Number Of Transaction"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={monthlyMaxNumber}
        onChange={e => setMonthlyMaxNumber(e.target.value)}
      />
      <TextField
        id="phone"
        label="Monthly Max Total Amount Of Transaction"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={monthlyMaxAmount}
        onChange={e => {
          setMOnthlyMaxAmount(e.target.value);
        }}
      /> */}
        {/* <TextField
        id="requirements"
        label="Requirement"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={currency}
        onChange={e => setCurrency(e.target.value)}
      /> */}

        {/* <FormControl variant="outlined" size="small" fullWidth className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="demo-simple-select-outlined-label">Requirements</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="select-multiple-chip"
          multiple
          value={requirements}
          onChange={handleChange}
          input={
            <Input
              id="select-multiple-chip"
              variant="outlined"
              // disableUnderline={true}
            />
          }
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}>
          {allRequirements.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}

        <div>
          <img src={preview} alt="" height="120px" className={classes.imgStyle} />
          <input accept="image/*" hidden id="contained-button-file" type="file" onChange={imageProcess} />

          <label htmlFor="contained-button-file">
            <Button
              id="uploadBtn"
              variant="outlined"
              color="primary"
              component="span"
              style={{ marginTop: '15px', borderRadius: '25px' }}
              fullWidth>
              <PhotoCamera /> Upload Image
            </Button>
          </label>
        </div>
        {/* <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div> */}

        <div>{/* <Loding/> */}</div>
        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            type="submit"
            disabled={loading}
            fullWidth>
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default TierAddEdit;
